const GET_PROGRAMME_GUIDES_LOADING =
  'programme_guides/GET_PROGRAMME_GUIDES_LOADING';
const GET_PROGRAMME_GUIDES_SUCCESS =
  'programme_guides/GET_PROGRAMME_GUIDES_SUCCESS';
const GET_PROGRAMME_GUIDES_ERROR =
  'programme_guides/GET_PROGRAMME_GUIDES_ERROR';

export {
  GET_PROGRAMME_GUIDES_LOADING,
  GET_PROGRAMME_GUIDES_SUCCESS,
  GET_PROGRAMME_GUIDES_ERROR
};
